import React from 'react';
import { Typography } from '@mui/material';
import Navbar from '../Header/Navbar';
import Footer from '../Header/Footer';
import { Stack } from '@mui/system';

const FAQ = () => {
  const faqItems = [
    {
      question: 'What is OptiGrit?',
      answer: 'OptiGrit is a cutting-edge online platform designed to empower individuals and organizations to create and manage their own educational video platforms. With OptiGrit, users can upload educational videos, organize contests, and cultivate vibrant learning communities.',
    },
    {
      question: 'How does OptiGrit work?',
      answer: 'OptiGrit provides users with intuitive tools to create customized educational video platforms. Users can sign up, personalize their platform, upload educational content, and even host contests to engage their audience. Our platform simplifies video hosting, community interaction, and contest management, enabling users to share knowledge effortlessly.',
    },
    {
      question: 'Who can benefit from using OptiGrit?',
      answer: "OptiGrit caters to a diverse range of users, including educators, content creators, businesses, and institutions seeking to disseminate educational content. Whether you're a teacher supplementing classroom lessons, a business providing employee training, or an organization sharing expertise, OptiGrit offers the platform to achieve your goals effectively.",
    },
    {
      question: 'What types of educational content can I upload on OptiGrit?',
      answer: 'You can upload a wide variety of educational content on OptiGrit, including tutorial videos, lectures, workshops, webinars, documentaries, and skill-based training materials.',
    },
    {
      question: 'How can I create contests on OptiGrit?',
      answer: 'Creating contests on OptiGrit is a streamlined process. Users have the flexibility to define contest parameters, including its title, contest questions, acceptable programming languages for submissions, constraints, as well as start and end times. Once the contest is set up, participants can easily submit their entries directly on the platform. Organizers play a pivotal role in managing submissions, evaluating entries, assigning scores, and ultimately determining winners based on pre-established criteria. This intuitive contest management system ensures a seamless experience for both organizers and participants, fostering an environment conducive to learning and competition.',
    },
    {
      question: 'Is OptiGrit free to use?',
      answer: 'OptiGrit offers both free and premium subscription options. The free plan provides basic features for creating and managing educational platforms, while premium plans offer additional customization options, enhanced features, and priority support.',
    },
    {
      question: 'How secure is OptiGrit for hosting educational content?',
      answer: 'At OptiGrit, we prioritize the security and privacy of user content. Our platform employs industry-standard security measures, including encryption protocols, to safeguard user data and content.',
    },
    {
      question: 'Can I monetize my content on OptiGrit?',
      answer: 'Yes, users can monetize their content on OptiGrit. Premium users have the option to offer paid access to their content, set subscription fees, or generate revenue through advertisements displayed on their platforms.',
    },
    {
      question: 'How can I get started with OptiGrit?',
      answer: 'To get started with OptiGrit, simply sign up for an account and customize your platform to suit your needs. Upload your content, engage with your audience, and cultivate a thriving educational community.',
    },
    {
      question: 'How can I get support if I have questions or encounter issues?',
      answer: 'For support inquiries or assistance, please reach out to us at support@optigrit.com. Our dedicated support team is available to address any questions or concerns you may have.',
    },
  ];

  return (
    <Stack gap={3}>
      <Navbar />

      <Stack sx={{
        width: '100%', alignItems: 'center', boxSizing: 'border-box', p: '20px',
        '& .section': {
          width: '100%', borderRadius: '16px', p: '16px', gap: 2,
          bgcolor: 'var(--color-bg-secondary)',
          boxSizing: 'border-box',
        },

        '& .heading': {
          fontSize: '32px', fontWeight: 'bold', paddingBottom: '4px',
          borderBottom: '1px solid var(--color-border)',
        },

        '& .content': {
          fontSize: '16px', color: 'var(--color-text-secondary)'
        }
      }} >
        <Stack sx={{ width: '100%', maxWidth: '1080px', gap: 3, alignItems: 'flex-start' }} >
          <Stack className='section' style={{ backgroundColor: 'transparent' }} >
            <Typography className='heading' >
              Frequently Asked Questions
            </Typography>

            <Typography className='content' >
              Find answers to common questions about OptiGrit and how to get the most out of our platform.
            </Typography>
          </Stack>

          {faqItems.map((item, index) => (
            <Stack key={index} className="section" >
              <Typography className="heading" >
                {String(index + 1).padStart(2, '0')} {item.question}
              </Typography>
              <Typography className="content" >
                {item.answer}
              </Typography>
            </Stack>
          ))}

          <Stack className="section" >
            <Typography className="heading" >
              Contact Us
            </Typography>
            <Typography className="content" >
              For further assistance or inquiries, feel free to contact us at support@optigrit.com. We look forward to supporting your educational endeavors on OptiGrit!
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Footer />
    </Stack>
  );
};

export default FAQ;
